import { render } from "./PopUp.vue?vue&type=template&id=77316d2c&scoped=true&ts=true"
import script from "./PopUp.vue?vue&type=script&lang=ts"
export * from "./PopUp.vue?vue&type=script&lang=ts"

import "./PopUp.vue?vue&type=style&index=0&id=77316d2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77316d2c"]])

export default __exports__